
// Router
import router from '@/app/routes/router.js';

// Vue Instance
import Vue from 'vue';

// Constants
import { GA } from '@/app/constants/ga-constants';
import { TOKEN } from '@/app/constants/status-constants';

const lmdcUser = {
	state: {
		userToken: null,
		isFromNativeApp: false,
		isClubAdmin: false,
		userDetails: {
			id: null,
			customerId: null,
			emailAddress: null,
			firstName: null,
			lastName: null,
			mobileNumber: null,
			address: null,
			status: null,
			pets: []
		},
		activePet: {
			id: null,
			name: null,
			imageUrl: null,
			birthdate: null,
			serialNumber: null,
			breed: {
				id: null,
				name: null
			}
		},
		comingSoon: {
			show: false,
			component: ''
		},
		subscriptions: {
			tracking: null
		},
		latitudePay:{
			gatewayReference: null,
            merchantReference: null,
            transactionReference: null,
            location: null
		},
		storeCredit: null,
		producType: null,
		breederDetails: {
			breederSysId: null,
			name: null
		},
		hasSwitchToBreederRole: false,
	},
	mutations: {
		setUserToken(state, userToken) {
			state.userToken = userToken;
		},
		setUserDetails(state, userDetails) {
			state.userDetails = {...userDetails};
		},
		toggleIsClubAdmin(state, isClubAdmin) {
			state.isClubAdmin = isClubAdmin;
		},
		setActivePet(state, petDetails) {
			state.activePet = petDetails;
		},
		setComingSoon(state, soonComponent) {
			state.comingSoon = {
				show: true,
				component: soonComponent
			};
		},
		clearComingSoon(state) {
			state.comingSoon = {
				show: false,
				component: ''
			};
		},
		setIsNativeApp(state, flag) {
			state.isFromNativeApp = flag;
		},
		clearLmdcUserDetails(state) {
			state.userDetails = {};
		},
		clearUserToken(state) {
			state.userToken = null;
		},
		setTrackingSubscription(state, tracking) {
			state.subscriptions.tracking = tracking;
		},
		setLatitudePay(state, latitudePay) {
			state.latitudePay = latitudePay;
		},
		clearLatitudePay(state){
			state.latitudePay = {
				gatewayReference: null,
				merchantReference: null,
				transactionReference: null,
				location: null
			}
		},
		setStoreCredit(state, storeCredit) {
			state.storeCredit = storeCredit;
		},
		setProductType(state, productType) {
			state.productType = productType;
		},
		setBreederDetails(state, breederDetails) {
			state.breederDetails = {...breederDetails};
		},
		setHasSwitchToBreederRole(state, flag) {
			state.hasSwitchToBreederRole = flag;
		},
		resetHasSwitchToBreederRole(state){
			state.hasSwitchToBreederRole = false;
		}
	},
	actions: {
		logout({commit}) {
			// remove user details when JWT expires.
			commit('clearLmdcUserDetails');
			commit('clearUserToken');
			commit('resetHasSwitchToBreederRole');
			
			// Send Logout Analytics
			Vue.prototype.$gtag.event(`${GA.USER_SETTINGS.LOG_OUT_BUTTON.ACTION}`, {
				event_category: GA.USER_SETTINGS.CATEGORY,
				event_label: GA.USER_SETTINGS.LOG_OUT_BUTTON.LABEL
			});
			

			router.push("/login").catch((err) => {
                window.location.href = "/login"; // Fallback in case of an issue
            });
			
		},
		initializeLogoutTimer({dispatch}) {
			// kills the running instance of set timeout if the user logs in again.
			clearTimeout();

			setTimeout(() => {
				dispatch('logout');
			}, TOKEN.EXPIRY);
		},
		showComingSoon({commit, state}) {
			let component;

			if (router.history.pending.name === 'Health Data') {
				component = 'Exercise';
			} else if (router.history.pending.name === 'Tracking') {
				// Check if the user has tracking subscription else we will show the modal
				const tracking = state.subscriptions.tracking;
				if (!tracking || !tracking.isTrackingDeviceConnected  || !tracking.trackingSerialNumber  || tracking.expiredSubscription || !tracking.subscriptionStatus || tracking.subscriptionStatus === 'I' || tracking.subscriptionStatus === 'C') {
					component = 'Tracking';
				}
			}

			if (component) {
				commit('setComingSoon', component);
			}
		},
	},
	getters: {
		getUserToken(state) {
			return state.userToken;
		},
		getUserDetails(state) {
			return state.userDetails;
		},
		getActivePet(state) {
			return state.activePet;
		},
		getComingSoon(state) {
			return state.comingSoon;
		},
		getIsNativeApp(state) {
			return state.isFromNativeApp;
		},
		getIsClubAdmin(state) {
			return state.isClubAdmin;
		},
		getSubscriptions(state) {
			return state.subscriptions;
		},
		getLatitudePay(state) {
			return state.latitudePay;
		},
		getStoreCredit(state) {
			return state.storeCredit;
		},
		getProductType(state) {
			return state.productType;
		},
		getBreederDetails(state) {
			return state.breederDetails;
		}, 
		getHasSwitchToBreederRole(state) {
			return state.hasSwitchToBreederRole;
		},

	}
};

export default lmdcUser;
